import { omit } from "lodash";

export const useParsedFieldProps = (props, options = {}) => {
  // Filter out the "parent" prop and other props defined in the `omit` option, so they're
  // not passed down to <Field>s and <Input>s.
  const propsWithoutOmitted = omit(props, ["parent", ...(options.omit || [])]);

  const {
    fieldName,
    label,
    required,
    hint,
    hintPosition,
    hide,
    fieldProps: passthroughFieldProps,
    inputProps: passthroughInputProps,
    ...extractedInputProps
  } = propsWithoutOmitted;

  const fieldProps = {
    fieldName,
    label,
    required,
    hint,
    hintPosition,
    hide,
    ...passthroughFieldProps
  };

  const inputProps = {
    fieldName,
    ...extractedInputProps,
    ...passthroughInputProps
  };

  return { fieldProps, inputProps };
};
